export default {
  init() {
    // JavaScript to be fired on woocommerce checkout cart
    $('#order_review_heading').hide();
    $('#order_review').hide();
    $('.order-details-title').hide();
    $('.order-confirmation').hide();

    $('#next').click(function(){
      goToStep2();
      updateBillingInfo();
    });

    $('.back-url').click(function(e){
      if($('#order_review').hasClass('active')){
        e.preventDefault();
        goToStep1();
      }
    });

    function updateBillingInfo(){
      var billingInfo = '';
      billingInfo += $('#billing_first_name').val() + ' ' + $('#billing_last_name').val() + '\n';
      billingInfo += $('#billing_email').val() + '\n';
      billingInfo += $('#billing_phone').val() + '\n';
      $('.billing-information-container').html(billingInfo);

      var billingAddress = '';
      billingAddress += $('#billing_address_2').val() + '\n';
      billingAddress += $('#billing_address_1').val() + '\n';
      billingAddress += $('#billing_city').val() + '/' + $('#billing_country').val() + '\n';
      billingAddress += $('#billing_postcode').val() + '\n';
      $('.billing-address-container').html(billingAddress);

      var deliveryAddress = '';
      if($('#ship-to-different-address-checkbox').prop('checked')){
        deliveryAddress += $('#shipping_address_2').val() + '\n';
        deliveryAddress += $('#shipping_address_1').val() + '\n';
        deliveryAddress += $('#shipping_city').val() + '/' + $('#shipping_country').val() + '\n';
        deliveryAddress += $('#shipping_postcode').val() + '\n';
      }else {
        deliveryAddress = billingAddress;
      }
      $('.delivery-address-container').html(deliveryAddress);
    }

    function goToStep1(){
      $('#order_review').hide();
      $('#order_review').removeClass('active');
      $('#next').show();
      $('#customer_details').show();
      $('h1').html('CHECKOUT');
      $('.order-details-title').hide();
      $('.order-confirmation').hide();
    }

    function goToStep2(){
      $('#order_review').show();
      $('#order_review').addClass('active');
      $('#next').hide();
      $('#customer_details').hide();
      $('h1').html('ORDER CONFIRMATION');
      $('.order-details-title').show();
      $('.order-confirmation').show();
    }

    $('body').on('DOMNodeInserted DOMNodeRemoved', '.woocommerce-NoticeGroup-checkout' ,function() {
      goToStep1();
    });
  },
  finalize() {
    // JavaScript to be fired on woocommerce checkout cart, after page specific JS is fired
    
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/woocommerceCheckout.js